// IM-XPR-001 (IM-UI-092, IM-ADR-015) — Qual experiência montar. A interface pergunta à API (IM-API-327) uma vez
// por sessão. Enquanto não sabe, não desenha nenhum dos dois shells (evita piscar a experiência errada). API antiga
// (404) ou erro = experiência anterior: a chave nunca liga nada por omissão.
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { ExperienceDto } from '@intelimove/contracts';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

interface ExperienceValue { ready: boolean; v2: boolean; journeys: boolean; opportunities: boolean; decisionBrief: boolean; opportunityRadar: boolean }
const OFF: ExperienceValue = { ready: true, v2: false, journeys: false, opportunities: false, decisionBrief: false, opportunityRadar: false };
const Ctx = createContext<ExperienceValue>(OFF);

export function ExperienceProvider({ children }: { children: ReactNode }) {
  const { status, me } = useAuth();
  const userId = me?.user.id ?? null;
  const [value, setValue] = useState<ExperienceValue>({ ready: false, v2: false, journeys: false, opportunities: false, decisionBrief: false, opportunityRadar: false });
  useEffect(() => {
    if (status !== 'authenticated') { setValue({ ready: status === 'anonymous', v2: false, journeys: false, opportunities: false, decisionBrief: false, opportunityRadar: false }); return; }
    let alive = true;
    setValue((v) => (v.ready ? v : { ready: false, v2: false, journeys: false, opportunities: false, decisionBrief: false, opportunityRadar: false }));
    api<ExperienceDto>('/api/v1/experience')
      .then((x) => alive && setValue({ ready: true, v2: x.v2 === true, journeys: x.journeys === true, opportunities: x.opportunities === true, decisionBrief: x.decisionBrief === true, opportunityRadar: x.opportunityRadar === true }))
      .catch(() => alive && setValue(OFF));
    return () => { alive = false; };
  }, [status, userId]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useExperience = () => useContext(Ctx);
